window.onload = function() {
    var checkPropertiesInterval = setInterval(function() {
        var properties = document.querySelectorAll('.upcart-item-property');
        var strongProperties = document.querySelectorAll('.upcart-item-property strong');
        
        properties.forEach(function(property) {
            if (property.textContent.includes('customization_image') || property.textContent.includes('tib_design_link')) {
                property.style.display = 'none';
            }
        });

        strongProperties.forEach(function(strongProperty) {
            if (strongProperty.textContent.includes('customization_image') || strongProperty.textContent.includes('tib_design_link')) {
                strongProperty.parentElement.style.display = 'none';
            }
        });
    }, 500); 
};